import { styled } from "@mui/material/styles";

const WrappersMain = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "20px",
  width: "100%",
}));

export { WrappersMain };
